module.exports = __webpack_public_path__ + "img/portfolio.837b1328.png";